import { render, staticRenderFns } from "./ConfidentialBuyerRegistration.vue?vue&type=template&id=198ee9aa&scoped=true&"
import script from "./ConfidentialBuyerRegistration.vue?vue&type=script&lang=ts&"
export * from "./ConfidentialBuyerRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ee9aa",
  null
  
)

export default component.exports